import {ConversionStep} from 'common/charts/visualization/conversion-column-viz/util';
import {renameEvent} from 'common/report/util/events';
import {formatPercent} from 'common/util';

import {TopPathsFlow} from './models/top-paths-flow';

export function getCommonConversionVizSteps(flowStep: TopPathsFlow): ConversionStep[] {
  const steps = flowStep.getSteps();
  return steps.map((step, index) => {
    if (step.isEmpty) {
      return {placeholder: true};
    }

    const displayName = renameEvent(step.event);

    let tooltipName: string;
    if (step.segments.length > 0) {
      const segments = step.getFormattedSegments().join(`, `);
      tooltipName = `${displayName} (${segments})`;
    }

    // We allow empty steps in top paths for multiple anchors v2,
    // so we adjust where to pull the conversion rate from to avoid those empty steps.
    let conversionRate = 1;
    for (let i = 1; index - i >= 0; i++) {
      if (steps[index - i].type !== `EMPTY`) {
        conversionRate = steps[index - i].conversionRate;
        break;
      }
    }

    return {
      displayName,
      tooltipName,
      bars: [
        {
          conversionRate,
          value: step.totalCount,
        },
      ],
      extras: step,
    };
  });
}

export function getOverallConversionRate(flowStep: TopPathsFlow) {
  const steps = flowStep.getSteps();
  const lastStepValue = steps.filter((step) => !step.isEmpty).slice(-1)[0]?.totalCount ?? 0;
  const maxStepValue = Math.max(...steps.map((step) => step.totalCount));

  return formatPercent(lastStepValue / maxStepValue);
}
